var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4560_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5419 0H6.45811C3.17279 0 0.5 2.67279 0.5 5.95811V14.0419C0.5 17.3272 3.17279 20 6.45811 20H14.5419C17.8272 20 20.5 17.3272 20.5 14.0419V5.95811C20.5 2.67279 17.8272 0 14.5419 0ZM18.488 14.0419C18.488 16.2213 16.7213 17.988 14.5419 17.988H6.45811C4.27875 17.988 2.512 16.2213 2.512 14.0419V5.95811C2.512 3.77871 4.27875 2.012 6.45811 2.012H14.5419C16.7213 2.012 18.488 3.77871 18.488 5.95811V14.0419Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 4.82727C7.64762 4.82727 5.32715 7.14774 5.32715 9.99994C5.32715 12.8521 7.64762 15.1727 10.4999 15.1727C13.3521 15.1727 15.6726 12.8522 15.6726 9.99994C15.6726 7.14771 13.3521 4.82727 10.4999 4.82727ZM10.4999 13.1607C8.75423 13.1607 7.33915 11.7456 7.33915 9.99998C7.33915 8.25435 8.75427 6.83927 10.4999 6.83927C12.2455 6.83927 13.6606 8.25435 13.6606 9.99998C13.6606 11.7456 12.2455 13.1607 10.4999 13.1607Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6828 6.10567C16.3673 6.10567 16.9223 5.55075 16.9223 4.86622C16.9223 4.18169 16.3673 3.62677 15.6828 3.62677C14.9983 3.62677 14.4434 4.18169 14.4434 4.86622C14.4434 5.55075 14.9983 6.10567 15.6828 6.10567Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4560_1586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.a2e460799ad177646a5f96531cbf5141.svg";
export { ForwardRef as ReactComponent };